/** Backend origin from REACT_APP_API_URL (rsa-agent/.env). No trailing slash. */
export const API_BASE_URL = (process.env.REACT_APP_API_URL || 'http://localhost:8000').replace(
    /\/+$/,
    '',
);

/** Auto-logout when there is no user activity for this long (web agent app). */
export const SESSION_TIMEOUT_MS = 5 * 60 * 1000;

export const API_ENDPOINTS = {
    AUTH: {
        LOGIN: '/api/auth/login',
        LOGOUT: '/api/auth/logout',
        ME: '/api/auth/me',
    },
    ADMIN: {
        ANALYTICS: '/api/admin/analytics/dashboard',
        USERS: '/api/admin/users',
        VENDORS: '/api/admin/vendors',
        SERVICES: '/api/admin/services',
        CONFIGURATION: '/api/admin/configuration',
    },
};

export const USER_ROLES = {
    ADMIN: 'admin',
    MANAGER: 'manager',
    DRIVER: 'driver',
    AGENT: 'agent'
};

export const SERVICE_STATUS = {
    DRAFT: 'draft',
    AWAITING_CUSTOMER_PAYMENT: 'awaiting_customer_payment',
    PENDING: 'pending',
    SCHEDULED: 'scheduled',
    VENDOR_SCHEDULED: 'vendor_scheduled',
    VENDOR_NOT_ACCEPTED: 'vendor_not_accepted',
    ASSIGNED: 'assigned',
    DRIVER_STARTED: 'driver_started',
    VENDOR_REACHED_BD_LOCATION: 'vendor_reached_bd_location',
    REPAIR_COMPLETE: 'repair_complete',
    SERVICE_COMPLETE: 'service_complete',
};

export const ALERT_STATUS = {
    PENDING: 'pending',
    ACCEPTED: 'accepted',
    REJECTED: 'rejected',
    EXPIRED: 'expired',
};

export const INVOICE_STATUS = {
    DRAFT: 'draft',
    SUBMITTED: 'submitted',
    APPROVED: 'approved',
    REJECTED: 'rejected',
    PAID: 'paid',
};

export const INVOICE_TYPE = {
    SERVICE: 'service',
    MISCELLANEOUS: 'miscellaneous',
};